import React, { useState } from 'react'
import { Stack, Box, TextField, Button, Paper, Typography, CircularProgress } from '@mui/material'
import { useForm } from 'react-hook-form'
import { theme } from '../../styles/theme'
import { useUser } from '../../hooks/useUser'
import { Turnstile } from '@marsidev/react-turnstile'
import { parseEmail, parsePassword } from '../../utils/validation'
import { useNavigate, useLocation } from 'react-router-dom'
import { TURNSTILE_ENABLED, TURNSTILE_SITE_KEY } from '../../config/api'

const buildPathWithQuery = (targetLocation) => {
  if (!targetLocation) {
    return '/'
  }

  return `${targetLocation.pathname || '/'}${targetLocation.search || ''}${targetLocation.hash || ''}`
}

const LoginForm = () => {
  const { loginUser } = useUser()
  const [loginMessage, setLoginMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const form = useForm({
    defaultValues: {
      email: '',
      password: '',
      turnsitleToken: ''
    }
  })
  const { from } = location.state || { from: { pathname: '/' } }

  const { register, handleSubmit, setValue, formState } = form
  const { errors } = formState

  const handleSuccess = (token) => {
    setValue('turnsitleToken', token)
  }

  const handleTokenReset = () => {
    setValue('turnsitleToken', '')
  }

  const onSubmit = async (data) => {
    setLoginMessage('')
    setLoading(true) // Start loading
    try {
      if (TURNSTILE_ENABLED && !data.turnsitleToken) {
        setLoginMessage('Completează verificarea captcha înainte de autentificare.')
        return
      }

      const message = await loginUser(data)
      setLoginMessage(message)
      if (localStorage.getItem('token')) {
        navigate(buildPathWithQuery(from))
      }
    } catch (error) {
      setLoginMessage('Login failed: ' + error.message)
    } finally {
      setLoading(false) // Stop loading regardless of outcome
    }
  }

  return (
    <Paper elevation={2} sx={{ padding: '30px 30px', display: 'flex', justifyContent: 'center' }}>
        <Stack spacing={2} width={{ xs: 300, sm: 300, md: 350, lg: 350, xl: 350 }}>
            <Box>
              <Typography variant='h5' sx={{ textAlign: 'center', color: theme.palette.fontColor.main, fontSize: '18px', marginBottom: '15px' }}>Bun venit la Primusvest Admin!</Typography>
            </Box>
            <form onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={2}>
            <TextField label="Email"
                size='small'
                inputProps={{ style: { fontSize: '14px', color: theme.palette.fontColor.main } }}
                InputLabelProps={{ style: { fontSize: '14px', color: theme.palette.fontColor.main } }}
                type='email' {...register('email', {
                  required: 'Câmp obligatoriu',
                  validate: value => parseEmail(value) === true || parseEmail(value)
                })}
                error={!!errors.email}
                helperText={errors.email?.message}
            />
            <TextField label="Parolă"
              size='small'
              inputProps={{ style: { fontSize: '14px', color: theme.palette.fontColor.main } }}
              InputLabelProps={{ style: { fontSize: '14px', color: theme.palette.fontColor.main } }}
              type="password" {...register('password', {
                required: 'Câmp obligatoriu',
                validate: value => parsePassword(value) === true || parsePassword(value)
              })}
              error={!!errors.password}
              helperText={errors.password?.message}
            />
            {TURNSTILE_ENABLED && (
              <Turnstile
                siteKey={TURNSTILE_SITE_KEY}
                onSuccess={handleSuccess}
                onError={(data) => {
                  console.log('turnstile error', data)
                  handleTokenReset()
                }}
                onExpire={(data) => {
                  console.log('turnstile expired', data)
                  handleTokenReset()
                }}
                options={{
                  action: 'submit',
                  theme: 'light',
                  size: 'normal',
                  appearance: 'interaction-only'
                }}
              />
            )}
              {loading
                ? (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <CircularProgress sx={{ color: '#ff0000' }}/>
                </div>
                  )
                : (
                <Button
                  type="submit"
                  variant="contained"
                  color='drawer'
                  sx={{ color: 'white', borderRadius: '21px' }}
                >
                  Intră în cont
                </Button>
                  )}
            </Stack>
            </form>
            {loginMessage && (
              <Typography variant="body1" style={{ textAlign: 'center', color: theme.palette.error.main }}>
                {loginMessage}
              </Typography>
            )}
        </Stack>
    </Paper>
  )
}

export default LoginForm
